import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SubSubSubSubGroup} from '../../model/sub-sub-sub-sub-group';
import {FormGroup} from '@angular/forms';
import {Field} from '../../model/field';
import {EformsSubjectService} from '../../services/eforms-subject.service';
import {EformDataService} from "../../services/eform-data.service";
import {EformConditionsService} from "../../services/eform-conditions.service";
import { EformDuplicableEntityService } from '../../services/eform-duplicable-entity.service';
import {EformAccordionService} from '../../services/eform-accordion.service';

@Component({
  selector: 'app-sub-sub-sub-sub-group',
  templateUrl: './sub-sub-sub-sub-group.component.html',
  styleUrls: ['../e-forms-generator/e-forms-generator.component.css']
})
export class SubSubSubSubGroupComponent implements OnInit, AfterViewInit {


  @Input() subSubSubSubGroup: SubSubSubSubGroup = {} as SubSubSubSubGroup;
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() noticeValue: any = {};
  @Output() newSubSubSubSubGroup = new EventEmitter();
  @Output() deleteSubSubSubSubGroup = new EventEmitter();
  @Input() repeatablePath: string;
  @Input() repeatablePathWithIndex: string;
  @Input() prefixId: string;
  @Input() subSectionId: string;
  @Input() linkForRouter: string;
  @Input() index: string;
  @Input() getRepeatablePathForDuplicableElementFromParent: () => string;

  repeatablePathForElementDuplicable: string;

  constructor(private eformsSubjectService: EformsSubjectService,
    private eformDuplicableEntityService: EformDuplicableEntityService, private eformDataService: EformDataService, private eformConditionService: EformConditionsService,
    private eformAccordionService: EformAccordionService) {
  }

  ngOnInit(): void {
    this.repeatablePathForElementDuplicable = this.getRepeatablePathForDuplicableElementFromParent();
  }

  ngAfterViewInit() {
    //Dans le cas de l'edition, on cherche les elements répétable à initialiser
    // 🔧 FIX 2026-02-11: Ne pas créer automatiquement des éléments pour les groupes nouvellement ajoutés manuellement
    const isManuallyAdded = this.subSubSubSubGroup?.id?.includes('_') && !this.subSubSubSubGroup?.id?.endsWith('_0');

    let elementToCreate = this.eformConditionService.findElementsToCreate(this.subSubSubSubGroup, this.repeatablePathWithIndex, this.noticeValue);

    if (elementToCreate?.length && !isManuallyAdded) {
      elementToCreate.forEach(e => {
        this.addSubSubSubSubGroup();
      });
    }
  }

  newField($event) {
    const field: Field = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.subSubSubSubGroup.fields.map(gr => gr.id);
    let elementNumber = 1;
    while (ids.includes(field.id.split('_')[0] + '_' + elementNumber)) {
      elementNumber++;
    }
    field.id = field.id.split('_')[0] + '_' + elementNumber;
    const indexToSplice = this.subSubSubSubGroup.fields.filter(el => el.id.startsWith($event.id)).length
    this.subSubSubSubGroup.fields.splice((this.subSubSubSubGroup.fields as any).findIndex(el => el.id === $event.id) + indexToSplice, 0, field);
    // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici
    this.repeatablePath = field.jsonPath + '_SEPSEP_' + (elementNumber);
  }

  deleteField($event: any) {
    this.subSubSubSubGroup.fields = this.subSubSubSubGroup.fields.filter(obj => obj !== $event);
    let deletedFieldIndex = +$event.id.split('_')[1];
    //On decale tous supérieurs à celui supprimé les id de 1 pour rester syncro avec les controls
    this.subSubSubSubGroup.fields.filter(f => f.id.includes('_')).forEach(f => {
      let splittedId = f.id.split('_');
      let actualIndex = +splittedId[1];
      if (actualIndex > deletedFieldIndex) {
        let newIndex = actualIndex - 1;
        f.id = splittedId[0] + '_' + newIndex;
      }
    });
  }

  addSubSubSubSubGroup() {
    this.newSubSubSubSubGroup.emit(this.subSubSubSubGroup);
  }

  removeSubSubSubSubGroup() {
    this.deleteSubSubSubSubGroup.emit(this.subSubSubSubGroup);
  }

  getRepeatablePathWithIndexForInput = (field): string => {
    if (field.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici
      return pathToReturn + this.isRepeatableField(field) + field.jsonPath + '_INDEX_' + (this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0');
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathForDuplicableElement = (): string =>{
    return this.repeatablePathForElementDuplicable
  }

  isRepeatableField(field) {
    if (field._repeatable) {
      let tempJsonPath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]') + 2);
      return tempJsonPath + '_INDEX_' + (this.eformDataService.getArray(field, this.formGroup, this.repeatablePathWithIndex, tempJsonPath)) + '_SEPSEP_';
    } else if (field.isJsonPathAlreadyUsed) {
      let tempJsonPath;
      let tmpPath;
      if (this.repeatablePathWithIndex) {
        tmpPath = field?.jsonPath?.replace(this.repeatablePathWithIndex.slice(0, this.repeatablePathWithIndex.indexOf('val')), '');
        let tmpPathArray: any[] = tmpPath.split('.');
        if (tmpPathArray.filter(e => e.includes('[]')).length > 1) {
          tmpPathArray.shift()
          tmpPath = tmpPathArray.join('.');
        }
        if (tmpPath.includes('fieldsprivacy')) {
          tmpPath = tmpPath?.slice(tmpPath.indexOf('fieldsprivacy'), tmpPath?.indexOf('val'));
        }
        tmpPath = tmpPath?.slice(0, tmpPath?.indexOf('[]'));
        tempJsonPath = field.jsonPath.slice(0, field.jsonPath.indexOf(tmpPath) + tmpPath.length);
      } else {
        tempJsonPath = field?.jsonPath?.slice(0, field?.jsonPath?.indexOf('[]'))
      }
      let pathElements = tempJsonPath.split('.');
      let tempControl = this.eformsSubjectService.getField(pathElements, this.formGroup, this.repeatablePathWithIndex);
      let index = 0;
      if (Array.isArray(tempControl?.controls)) {
        let count = 0;
        const pathToCheck = field?.jsonPath?.replaceAll('[]', '').split('.').slice(field?.jsonPath?.replaceAll('[]', '').split('.').indexOf(pathElements[pathElements.length - 1]) + 1, field?.jsonPath?.replaceAll('[]', '').split('.').indexOf('val'));
        if (pathToCheck.length > 1) {
          let i = 0;
          for (const element of tempControl?.controls) {
            if (element.get(pathToCheck[i]) && !Array.isArray(element.get(pathToCheck[i])?.controls)) {
              if (this.checkPathrecursively(element.get(pathToCheck[i]), pathToCheck, i + 1, pathToCheck[pathToCheck.length - 1])) {
                count++
              }
            }
          }
        } else {
          for (const element of tempControl?.controls) {
            if (element.get(pathToCheck[0])) {
              count++
            }
          }
        }

        index = count;
      }
      return tempJsonPath + '[]' + '_INDEX_' + index + '_SEPSEP_';
    } else {
      return '';
    }
  }

  checkPathrecursively(tmpElement, elements, index, lastElement): boolean {
    let isFound = false;
    if (Array.isArray(tmpElement?.controls)) {
      return false;
    } else {
      if (tmpElement?.controls[elements[index]]) {
        if (elements[index] != lastElement) {
          this.checkPathrecursively(tmpElement?.controls[elements[index]], elements, index + 1, lastElement)
        } else {
          return true;
        }
      }
    }
    return isFound;
  }

    getIndex(id: string) {
      let element = id.split("_");
      return {value: id.split("_")[element.length - 1], bool: element.length > 1};
    }

    parcoursUtilisateur(subSubSubSubGroup){
        return subSubSubSubGroup.parcoursUtilisateur?.messageInfo;
    }

    /**
     * 🔧 FIX 2026-02-26: Extrait le type de groupe à partir d'un ID
     * Ex: "GR-Lot-AwardCriteria-Criterion_1" -> "GR-Lot-AwardCriteria-Criterion"
     */
    getGroupType(elementId: string): string {
      return this.eformAccordionService.extractGroupType(elementId);
    }
}
